import { Market, MarketsGroupedByMarketType, Outcome, PublishedEventParticipants } from '../../../@types';
import MarketAccordion from '../../molecules/MarketAccordion';
import MarketTable from '../tables/MarketTable';
import MarketTableDisplaySingle from '../tables/MarketTableDisplaySingle';
import MarketsTableDisplayMultiple from '../tables/MarketsTableDisplayMultiple';
import MarketsTableTeamGrouped from '../tables/MarketsTableTeamGrouped';
import { MARKET_TYPE_ASIAN_HANDICAP_WITH_SCORE } from '../../../constants';

export const getAccordionTitle = (market: Market | MarketsGroupedByMarketType) => {
  if ('markets' in market) {
    const firstMarket = market.markets[0];
    if (firstMarket?.marketType?.name === MARKET_TYPE_ASIAN_HANDICAP_WITH_SCORE) {
      const match = firstMarket?.name.match(/\\[(.*?)\\]/); // extract the score data from market name
      const name = market?.shortName || market?.name;
      if (name.includes(',')) {
        const splitName = name.split(',');
        return `${splitName[0]}${match ? `(${match[1]})` : ''},${splitName[1]}`;
      }
      return (market?.shortName || market.name) + (match ? ` (${match[1]})` : '');
    }
    return market?.shortName || market.name;
  } else if (market.specialValues?.length > 0) {
    return market?.shortName || market.name || `${market.name} - ${market.specialValues[0].model?.name ?? ''}`;
  } else {
    return market?.shortName || market.name;
  }
};

type OMMarketRendererProps = {
  market: Market | MarketsGroupedByMarketType;
  onCellClick: (market: Market, outcome: Outcome) => void;
  eventParticipants?: PublishedEventParticipants;
};

const OMMarketRenderer = ({ market, onCellClick, eventParticipants }: OMMarketRendererProps) => {
  const commonProps = {
    defaultExpanded: true,
    showFavorites: true,
    isFavoriteMarket: market.favourite,
  };

  const renderCorrectMarketTable = (currentMarket: Market) => {
    if (currentMarket.specialValues?.length > 0) {
      return <MarketTableDisplaySingle data={currentMarket} handleCellClick={onCellClick} />;
    } else if (currentMarket.displayType === 'TEAM' && eventParticipants) {
      return <MarketsTableTeamGrouped data={currentMarket} handleCellClick={onCellClick} teams={eventParticipants} />;
    }
    return <MarketTable data={currentMarket} handleCellClick={onCellClick} />;
  };

  if ('markets' in market) {
    return (
      <MarketAccordion
        {...commonProps}
        key={market.id}
        marketId={market.marketType}
        title={getAccordionTitle(market)}
        marketTypeName={market.marketType as unknown as string}
        description={market.description}
      >
        <MarketsTableDisplayMultiple data={market} handleCellClick={onCellClick} />
      </MarketAccordion>
    );
  }
  return (
    <MarketAccordion
      {...commonProps}
      key={market.id}
      marketId={market.marketTypeId}
      title={getAccordionTitle(market)}
      marketTypeName={market.marketType.name as unknown as string}
      description={market.description}
    >
      {renderCorrectMarketTable(market)}
    </MarketAccordion>
  );
};

export default OMMarketRenderer;
